var version = {
    "name":      "dativery",
    "buildDateCode": "20251209-113503",
    "buildDate": "Tue Dec 09 2025 11:35:03 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251209-113503",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;